import BaseModelAPI from '../BaseModelAPI';

export default class SifatSurat extends BaseModelAPI {
	static entity = 'sifatsurat';
	static entityName = 'sifatsurat';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}